import NotificationIcons from "../NotificationIcons/NotificationIcons";
import HeaderWorkloadIcon from "./HeaderWorkloadIcon";
import { useSecurityRights } from "../../hooks/useSecurityRights";
import { workloadMenuId } from "screens/Root/utils/constants";
import { useNotificationsSelector } from "screens/Root/hooks/useAppSelector";
const HeaderNotificationsContainer = () => {
    const workloadSecurityRights = useSecurityRights(workloadMenuId);
    const { notifications, directNotifications, initialized } = useNotificationsSelector();
    const hideDivider = initialized &&
        notifications.length === 0 &&
        directNotifications.length === 0 &&
        !workloadSecurityRights.loading &&
        !workloadSecurityRights.hasAccess;
    return (<>
      {!hideDivider && <div className="divider"></div>}
      <HeaderWorkloadIcon loading={workloadSecurityRights.loading} visible={workloadSecurityRights.hasAccess}/>

      <NotificationIcons isTaskListVisible={workloadSecurityRights.hasAccess}/>
      <div className="divider"></div>
    </>);
};
export default HeaderNotificationsContainer;
